import { render } from "./ReceitasView.vue?vue&type=template&id=856f4bac"
import script from "./ReceitasView.vue?vue&type=script&lang=js"
export * from "./ReceitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__